// src/components/PublicHeader.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaDiscord } from "react-icons/fa";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem
} from "reactstrap";
import "./PublicHeader.css";
import logoSm from "../assets/images/logo-sm.png";

const PublicHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(prev => !prev);
  const closeMenu = () => setIsOpen(false);

  // Close collapse on route change
  const location = useLocation();
  useEffect(() => {
    closeMenu();
  }, [location]);

  return (
    <header className="public-header">
      <Navbar expand="lg" dark className="container-fluid px-0 align-items-center">
        <NavbarBrand tag={Link} to="/" className="ps-3">
          <img src={logoSm} alt="Pokémon Radiance" height="30" />
        </NavbarBrand>

        <NavbarToggler onClick={toggle} className="me-3 d-lg-none" />

        <Collapse isOpen={isOpen} navbar className="justify-content-end pe-3 align-items-center">
          <Nav navbar className="align-items-center">
            {['/', '/about', '/faq', '/login', '/register'].map((path, idx) => (
              <NavItem key={idx}>
                <Link
                  to={path}
                  className={idx < 3 ? 'nav-link' : `btn btn-${idx===3?'outline-light':'danger'} btn-sm me-2`}
                  onClick={closeMenu}
                >
                  {['Home', 'About Us', 'FAQ', 'Login', 'Register'][idx]}
                </Link>
              </NavItem>
            ))}
            <NavItem>
              <a
                href="https://discord.gg/mE9jv3xeP9"
                target="_blank"
                rel="noopener"
                className="nav-link discord-link"
                onClick={closeMenu}
              >
                <FaDiscord size={28} />
              </a>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </header>
  );
};

export default PublicHeader;